import HideHeaderButtons from 'src/javascripts/components/tables/checkboxes/HideHeaderButtons';
import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';

// Bulk disable using selected record IDs from a table
export default function(tableId) {

  // On disable bulk
  $('.disable-bulk').off().on('click', function() {
    let url = $(this).data('url');
    let params = {};
    params['record_ids'] = $('#' + tableId).data('record-ids');
    $.ajax({
      type: 'DELETE',
      dataType: 'application/json',
      url: url + '?' + $.param(params),
      complete(response) {
        $('#' + tableId).DataTable().ajax.reload();
        let result = response.responseText
        ToastCustom({title: 'Success', message: 'Successfully removed selected records', delay: 8000});
        HideHeaderButtons(tableId);
      },
      error: function(xhr) {
        $('#' + tableId).DataTable().ajax.reload();
        let errorMessage = "Failed to remove records";
        let errorTitle = "Error";
        if (xhr.responseJSON) {
          errorTitle = xhr.responseJSON.title || errorTitle;
          errorMessage = xhr.responseJSON.message || errorMessage;
        }
        ToastCustom({title: errorTitle, message: errorMessage, delay: 8000, autohide: true, type: "warning"});
        HideHeaderButtons(tableId);
      }
    });
  })

}